// extracted by mini-css-extract-plugin
export default {"reviews":"Reviews_reviews__Y95sa","reviewsWrapper":"Reviews_reviewsWrapper__UjvR9","reviewsItemHeader":"Reviews_reviewsItemHeader__Rkve-"};